// extracted by mini-css-extract-plugin
module.exports = {"containerBox":"styles_containerBox__11NBi","iconBox":"styles_iconBox__1b3Af"};